var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M17.364 8.283H.784a.698.698 0 0 1 0-1.395h16.58a.698.698 0 0 1 0 1.395M13.21 11.916a.7.7 0 0 1-.701-.698c0-.385.308-.697.693-.697h.008a.698.698 0 0 1 0 1.395M9.082 11.916a.7.7 0 0 1-.701-.698c0-.385.308-.697.693-.697h.008a.698.698 0 0 1 0 1.395M4.945 11.916a.7.7 0 0 1-.702-.698c0-.385.309-.697.694-.697h.008a.698.698 0 0 1 0 1.395M13.21 15.531a.7.7 0 0 1-.701-.698c0-.385.308-.697.693-.697h.008a.698.698 0 0 1 0 1.395M9.082 15.531a.7.7 0 0 1-.701-.698c0-.385.308-.697.693-.697h.008a.698.698 0 0 1 0 1.395M4.945 15.531a.7.7 0 0 1-.702-.698c0-.385.309-.697.694-.697h.008a.698.698 0 0 1 0 1.395M12.832 4.457a.7.7 0 0 1-.698-.698V.698a.698.698 0 0 1 1.395 0v3.061a.7.7 0 0 1-.697.698M5.317 4.457a.7.7 0 0 1-.698-.698V.698a.698.698 0 0 1 1.395 0v3.061a.7.7 0 0 1-.697.698",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "icon-calendar_svg__a",
  width: 19,
  height: 19,
  x: 0,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M0 1.469h18.14v18.53H0z",
  clipRule: "evenodd"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#icon-calendar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#946952",
  fillRule: "evenodd",
  d: "M5.136 2.864c-2.412 0-3.74 1.287-3.74 3.622v8.418c0 2.387 1.328 3.7 3.74 3.7h7.868c2.412 0 3.74-1.289 3.74-3.63V6.487c.004-1.148-.305-2.041-.918-2.655-.63-.633-1.603-.967-2.814-.967zM13.004 20H5.136C1.968 20 0 18.047 0 14.904V6.486C0 3.391 1.968 1.47 5.136 1.47h7.876c1.59 0 2.904.476 3.802 1.376.872.875 1.33 2.134 1.326 3.643v8.487c0 3.1-1.969 5.025-5.136 5.025",
  clipRule: "evenodd"
}))));
export default SvgIconCalendar;